import { combineReducers } from "@reduxjs/toolkit";
import { authSlice } from "./entities/auth/auth.redux";
import { quizSlice } from "./entities/quiz/quiz.redux";

export const reducers = combineReducers({
	auth: authSlice.reducer,
	quiz: quizSlice.reducer,
});
